// extracted by mini-css-extract-plugin
export default {"shortcut":"shortcut__k7B4hC","shortcutLabel":"shortcutLabel__pPzmTl","shortcutKeys":"shortcutKeys__XLM6Sl","shortcutKey":"shortcutKey__vVBp4R","shortcutPlus":"shortcutPlus__zeahCh"};